<template>
	<div class="wrap">
		<div class="ftr-1">
			<!-- 行事历 -->
			{{$t('studentsCom.calendar')}}
		</div>
		<div class="flex alcenter mb-3 mt-3">
			<div class="border-gray br4 px-3  d-flex align-content-center py-2" @click="preMonth">
				<a-icon type="left" style="font-size: 14px;"></a-icon>
			</div>
			<div class="border-gray br4 px-3 d-flex align-content-center py-2" @click="nextMonth">
				<a-icon type="right" style="font-size: 14px;"></a-icon>
			</div>
			<div class="ml10 ftr-1">
				{{curMonth}}{{$t('studentsCom.month')}} {{curYear}}
			</div>
		</div>
		<a-spin :spinning="loading">
			<div class="border-gray ftr-1 p-2">
				<div class="weeks">
					<div v-for="item in week" :key="item" class="week" style="padding-left: 10px;">{{ item }}</div>
				</div>
				<div class="days">
					<!-- 上个月 -->
					<div v-for="item in firstDay - 1" :key="item + 'pre'" class="lastday">
						{{ preDays - (firstDay - 1 - item) }}
					</div>
					<!-- 当月 -->
					<div v-for="(item,index) in monthList" :key="item.day + 'cur'" class="curday">
						<div class="selected-no" :class="{ 'selected': isSelected(curYear, curMonth, item) }">
							{{ item.day }}
						</div>
						<div class="border-theme ft14 cl-theme br12 py-1 px-2 mt-2" v-if="item.order.length!=0" 
						@click="toTeacherConfirms(item.order[0].id)">
							{{item.order[0].split_start_time.hour}}:{{item.order[0].split_start_time.minute}} {{item.order[0].course_name}}
						</div>
					</div>
					<!-- 下个月 -->
					<div v-for="item in 7 - nextDays" :key="item + 'next'" class="lastday">
						{{ item }}
					</div>
				</div>
			</div>
		</a-spin>
	</div>
</template>
<script>
	import moment from 'moment';
	moment.suppressDeprecationWarnings = true;
	export default {
		data() {
			return {
				preDays: 30,
				nextDays: 7,
				curYear: moment().year(), //当前年
				curMonth: moment().month() + 1, //当前月
				week: ['一', '二', '三', '四', '五', '六', '日'],
				firstDay: moment(`${moment().year()}-${moment().month() + 1}`)
					.startOf('month')
					.day(), //获取当月第一天是星期几;星期日为 0，星期六为 6
				curDays: moment().daysInMonth(), //获取当月一共有多少天
				 selectedDate: moment().format('YYYY-MM-DD'),
				 orderList:[],
				 monthList:[],
				 loading:false
			};
		},
		watch:{
			curMonth(newvalue){
				this.getMonth()
				this.getList()
			}
		},
		mounted() {
			this.getPreMonthDays();
			this.getNextMonthDays();
		},
		created(){
			this.getMonth()
			this.getList()
		},
		methods: {
			getMonth(){
				this.monthList = []
				for(let i = 1;i<=this.curDays;i++){
					this.monthList.push({
						day:i,
						order:[]
					})
				}
			},
			getList(){
				if(this.loading) return
				this.loading = true
				this.$http.api('reservation/orderList',{
					page:1,
					limit:100,
					start_time:`${this.curYear}-${this.curMonth}-01` ,
					finish_time:`${this.curYear}-${this.curMonth}-${this.curDays}`
				}).then(res=>{
					this.loading = false
					this.orderList = res.list
					this.monthList.forEach((item,index)=>{
						this.orderList.forEach((t,i)=>{
							if(t.split_start_time.day==item.day){
								item.order.push(t)
							}
						})
					})
				})
			},
			toTeacherConfirms(id){
				this.$router.push('/teacherConfirms?id='+id)
			},
			// 检查日期是否被选中
			isSelected(year, month, day) {
				const date = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD').format('YYYY-MM-DD');
				return date === this.selectedDate;
			},
			preMonth() {
				this.curMonth--;
				// 如果小于1表示上一年;重置日期
				if (this.curMonth < 1) {
					this.curYear--;
					this.curMonth = 12;
				}
				this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth();
				this.firstDay = moment(`${this.curYear}-${this.curMonth}`).startOf('month').day();
				if (this.firstDay == 0) {
					this.firstDay = 7;
				}
				// 显示上个月日期
				this.getPreMonthDays();
				this.getNextMonthDays();
			},
			nextMonth() {
				this.curMonth++;
				// 如果超过12表示下一年;重置日期
				if (this.curMonth > 12) {
					this.curYear++;
					this.curMonth = 1;
				}
				this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth();
				this.firstDay = moment(`${this.curYear}-${this.curMonth}`).startOf('month').day();
				if (this.firstDay == 0) {
					this.firstDay = 7;
				}
				// 显示上个月日期
				this.getPreMonthDays();
				this.getNextMonthDays();
			},
			// 获取上个月剩余天数
			getPreMonthDays() {
				if (this.firstDay == 1) return; //表示上个月无剩余天数
				let month = this.curMonth;
				let year = this.curYear;
				month--;
				if (month == 0) {
					year--;
					month = 12;
				}
				// 获取上个月的天数
				const days = moment(`${year}-${month}`).daysInMonth();
				this.preDays = days;
			},
			// 获取下个月要显示的天数
			getNextMonthDays() {
				let month = this.curMonth;
				let year = this.curYear;
				// 获取当月最后一天是星期几
				const lastDay = moment(`${year}-${month}`).endOf('month').day();
				this.nextDays = lastDay == 0 ? 7 : lastDay;
			}
		}
	};
</script>

<style lang="less" scoped>
	
	.wrap {
		// width: 700px;
		height: 100%;

		.weeks {
			width: 100%;
			height: 40px;
			display: flex;

			.week {
				width: calc(100% / 7);
				height: 40px;
				// text-align: center;
				// background: gainsboro;
			}
		}

		.days {
			display: flex;
			flex-wrap: wrap;

			.lastday,
			.curday {
				width: calc(100% / 7);
				height: 100px;
				// text-align: center;
				display: flex;
				// justify-content: center;
				// align-items: center;
				padding: 0 4px;
				flex-direction: column;
				.selected {
					background-color: #FF5F5F; // 选中状态的背景颜色
					color: white; // 选中状态的文字颜色
					width: 30px;
					height: 30px;
					line-height: 30px;
					border-radius: 50%;
					text-align: center;
				}
				.selected-no{
					width: 30px;
					height: 30px;
					line-height: 30px;
					border-radius: 50%;
					text-align: center;
				}
				
			}
			
			.lastday {
				color: #D2D2D2;
			}
		}
	}
</style>